import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';

const SuspensionGuard = ({ children }) => {
    const { user } = useSelector((state) => state.auth);

    // If user is suspended, block access
    if (user?.suspended) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[60vh] p-6 text-center">
                <div className="bg-red-50 p-6 rounded-full mb-6">
                    <ShieldAlert className="w-16 h-16 text-red-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Compte Suspendu</h2>
                <p className="text-gray-600 max-w-md mb-8">
                    Votre compte a été suspendu. Vous ne pouvez pas accéder à cette fonctionnalité pour le moment.
                    Veuillez contacter le support pour plus d'informations.
                </p>
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 max-w-md w-full text-left">
                    <h3 className="text-sm font-semibold text-red-800 mb-1">Restrictions actives :</h3>
                    <ul className="list-disc list-inside text-sm text-red-700 space-y-1">
                        <li>Création d'offres d'emploi</li>
                        <li>Création de missions freelance</li>
                        <li>Accès à la CVThèque</li>
                        <li>Gestion des candidatures</li>
                    </ul>
                </div>
            </div>
        );
    }

    return children;
};

export default SuspensionGuard;
